import * as Sentry from '@sentry/react';

const isProd = import.meta.env.REACT_APP_ENVIRONMENT === 'prod';

const API_URL = import.meta.env.REACT_APP_HOSTNAME_V2;

if (isProd) {
  Sentry.init({
    dsn: 'https://445e2fd7a0be679d60c4f00aaf57206a@o4510388314243072.ingest.us.sentry.io/4510388385611776',
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        networkDetailAllowUrls: [API_URL, 'https://cognito-idp.us-west-2.amazonaws.com/', 'https://api.stripe.com/'],
        networkCaptureBodies: true,
        // backend trace id for log correlation
        networkResponseHeaders: ['X-Trace-Id'],
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[500, 599]],
        failedRequestTargets: [API_URL],
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event, hint) {
      const error = hint?.originalException as Error | undefined;

      const message = error?.message || event.message || event.exception?.values?.[0]?.value || '';

      if (
        message.includes('Unable to preload CSS') ||
        message.includes('Loading CSS chunk') ||
        message.includes('ChunkLoadError') ||
        message.includes('Importing a module script failed') ||
        message.includes('is not a valid JavaScript MIME type') ||
        message.match(/\.css($|\?)/) ||
        message.match(/\.js($|\?)/) ||
        message.includes('ResizeObserver loop limit exceeded') ||
        message.includes('Script error.') ||
        message.includes('Non-Error promise rejection') ||
        message.includes('WKWebView API client did not respond') ||
        message.includes("reading 'postMessage'") ||
        message.includes('postMessage') ||
        message.includes('runtime.sendMessage') ||
        message.includes('Converting circular structure to JSON')
      ) {
        return null;
      }

      if (event.contexts?.response) {
        event.tags = { ...event.tags, 'error.origin': 'backend' };

        const method = event.request?.method || 'UNKNOWN';
        const url = event.request?.url || '';
        const path = new URL(url, 'https://placeholder').pathname
          .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/:id')
          .replace(/\/\d+/g, '/:id');
        const statusCode = event.contexts.response.status_code;

        event.fingerprint = ['http-client-error', method, path, String(statusCode)];
      }

      return event;
    },
  });
}

export default Sentry;
